<template>
  <div class="dashboard-modern">
    <NavBar
      v-if="
        terms == 1 &&
        (geolocation == 0 || (geolocation == 1 && terms_geolocation == 1))
      "
    />

    <AuthBySessionExpired />

    <div
      v-if="
        terms == 1 &&
        (geolocation == 0 || (geolocation == 1 && terms_geolocation == 1))
      "
      class="container"
    >
      <div class="dashboard-header">
        <div class="header-content">
          <h1 class="page-title">Residentes</h1>
          <div class="header-stats">
            <div
              v-if="$store.state.online && duty && permission('write', 'duty')"
            >
              Plantão iniciado no dia {{ formatDate(duty.created_at) }}
              <v-btn class="btn-finish-modern" @click="openModal">
                <i class="fas fa-briefcase-medical mr-2"></i>
                <span>Finalizar Plantão</span>
              </v-btn>
            </div>

            <v-btn
              v-if="$store.state.online && !duty && permission('write', 'duty')"
              class="btn btn-night-service"
              @click="openModal"
            >
              <i class="fas fa-briefcase-medical mr-2"></i>
              Iniciar Plantão
            </v-btn>

            <div class="stat-item">
              <span class="stat-number">{{ total }}</span>
              <span class="stat-label">Total</span>
            </div>
          </div>
        </div>

        <Duty @checkPeriodDuty="checkPeriodDuty" :duty="duty" />

        <div
          v-if="!loading && missing_security_questions"
          class="security-alert mt-2"
        >
          <div class="alert-content">
            <i class="fas fa-exclamation-triangle alert-icon"></i>
            <span class="alert-text">
              Verifique as questões de segurança para liberar o acesso OFFLINE!
            </span>
            <button
              @click="
                $router.push({
                  name: 'account',
                  query: { question_answer: true },
                })
              "
              class="alert-button"
            >
              Configurar
            </button>
          </div>
        </div>
      </div>

      <div class="filters-section" v-if="$store.state.online">
        <div class="filters-grid">
          <div class="filter-group">
            <label class="filter-label">
              <i class="fas fa-filter filter-icon"></i>
              Gênero
            </label>
            <v-select
              dense
              :items="genders"
              v-model="gender"
              outlined
              hide-details
              class="modern-select"
              @change="getResidents"
            />
          </div>

          <div class="filter-group">
            <label class="filter-label">
              <i class="fas fa-search filter-icon"></i>
              Pesquisar
            </label>
            <v-text-field
              dense
              placeholder="Nome do residente"
              outlined
              hide-details
              v-model="name"
              class="modern-input"
              @input="getResidents"
            />
          </div>

          <div class="filter-group">
            <label class="filter-label">
              <i class="fas fa-heart filter-icon"></i>
              Cuidados
            </label>
            <v-select
              dense
              :items="typesFilterByCare"
              v-model="filterCare"
              outlined
              hide-details
              class="modern-select"
              @change="handleFilterByCare"
            />
          </div>

          <div class="filter-group">
            <label class="filter-label">
              <i class="fas fa-chart-line filter-icon"></i>
              Dependência
            </label>
            <v-select
              dense
              :items="typesFilterByGrau"
              v-model="degree_of_dependence_id"
              outlined
              hide-details
              class="modern-select"
              @change="getResidents"
            />
          </div>
        </div>
      </div>

      <div class="residents-section">
        <b-overlay :show="loading" opacity="0.99" class="loading-overlay">
          <div class="residents-grid">
            <div
              v-for="resident in residents"
              :key="resident.id"
              class="resident-card"
            >
              <div class="card-header" @click="handleToResident(resident.id)">
                <div class="resident-avatar">
                  <img
                    :src="
                      permission('read', 'resident_photo') && resident.photo_url
                        ? resident.photo_url
                        : require('../assets/user.png')
                    "
                    :alt="resident.name"
                    class="avatar-image"
                  />
                  <div
                    class="avatar-status"
                    :class="{ online: resident.existPrescription }"
                  ></div>
                </div>

                <div class="resident-info">
                  <h3 class="resident-name">{{ resident.name }}</h3>
                  <p class="resident-nickname" v-if="resident.nickname">
                    {{ resident.nickname }}
                  </p>
                  <p
                    class="resident-age"
                    v-if="resident.date_of_birth && $store.state.online"
                  >
                    {{ getAge(resident.date_of_birth) }} anos
                  </p>

                  <p
                    class="resident-prescription resident-with-prescription"
                    v-if="resident.existPrescription"
                  >
                    Com prescrição diária
                  </p>
                  <p
                    class="resident-prescription resident-no-prescription"
                    v-if="!resident.existPrescription"
                  >
                    Sem prescrição diária
                  </p>

                  <p
                    class="resident-prescription resident-with-prescription"
                    v-if="resident.existPrescriptionLongTerm"
                  >
                    Com prescrição longo prazo
                  </p>
                </div>
              </div>

              <div class="alerts-section" v-if="$store.state.online">
                <div
                  v-if="resident.pendingChecks.length > 0"
                  class="alert-item"
                >
                  <tippy
                    arrow
                    theme="light"
                    trigger="click"
                    interactive
                    placement="bottom"
                  >
                    <template v-slot:trigger>
                      <div class="alert-badge alert-delayed-medication">
                        <i class="fas fa-capsules"></i>
                        Medicamentos atrasados
                        <span class="badge-count">{{
                          resident.pendingChecks.length
                        }}</span>
                      </div>
                    </template>
                    <div class="tooltip-content">
                      <h6 class="tooltip-title">Medicamentos atrasados</h6>
                      <div
                        v-for="(item, key) in resident.pendingChecks"
                        :key="key"
                        class="tooltip-item"
                      >
                        <span class="tooltip-date">{{
                          formatDate(item.date, false)
                        }}</span>
                        <button
                          @click="
                            handleToResidentByCheck(resident.id, item.date)
                          "
                          class="tooltip-action"
                        >
                          Checar
                        </button>
                      </div>
                    </div>
                  </tippy>
                </div>

                <div v-if="resident.pendingCares.length > 0" class="alert-item">
                  <tippy
                    arrow
                    theme="light"
                    trigger="click"
                    interactive
                    placement="bottom"
                  >
                    <template v-slot:trigger>
                      <div class="alert-badge alert-warning">
                        <i class="fas fa-exclamation"></i>
                        <span>Cuidados Pendentes</span>
                        <span class="badge-count">{{
                          resident.pendingCares.length
                        }}</span>
                      </div>
                    </template>
                    <div class="tooltip-content">
                      <h6 class="tooltip-title">Cuidados Pendentes</h6>
                      <div
                        v-for="(item, key) in resident.pendingCares"
                        :key="key"
                        class="tooltip-item"
                      >
                        <div class="care-info">
                          <p class="care-type">
                            {{
                              item.type == "ANNOTATION"
                                ? "ANOTAÇÃO"
                                : "SINAIS VITAIS"
                            }}
                          </p>
                          <p class="care-date">
                            {{
                              String(item.created)
                                .split("-")
                                .reverse()
                                .join("/")
                            }}
                          </p>
                          <p class="care-caregiver">{{ item.user_name }}</p>
                        </div>
                        <button
                          @click="handleToUserCare(resident.id, item.created)"
                          class="tooltip-action"
                        >
                          Acessar
                        </button>
                      </div>
                    </div>
                  </tippy>
                </div>

                <div
                  v-if="resident.pendingSemiology.length > 0"
                  class="alert-item alert-info"
                >
                  <tippy
                    arrow
                    theme="light"
                    trigger="click"
                    interactive
                    placement="bottom"
                  >
                    <template v-slot:trigger>
                      <div class="alert-badge">
                        <i class="fas fa-edit"></i>
                        <span>Semiologia</span>
                        <span class="badge-count">{{
                          resident.pendingSemiology.length
                        }}</span>
                      </div>
                    </template>
                    <div class="tooltip-content">
                      <h6 class="tooltip-title">Formulários Pendentes</h6>
                      <div
                        v-for="(item, key) in resident.pendingSemiology"
                        :key="key"
                        class="tooltip-item"
                      >
                        <div class="care-info">
                          <p class="care-date">
                            {{
                              String(item.created)
                                .split("-")
                                .reverse()
                                .join("/")
                            }}
                          </p>
                          <p class="care-caregiver">{{ item.user_name }}</p>
                        </div>
                        <button
                          @click="
                            handleToResidentBySemiology(
                              resident.id,
                              item.created
                            )
                          "
                          class="tooltip-action"
                        >
                          Finalizar
                        </button>
                      </div>
                    </div>
                  </tippy>
                </div>

                <div
                  v-if="resident.pendingChecksLongTerm.length > 0"
                  class="alert-item alert-success"
                >
                  <tippy
                    arrow
                    theme="light"
                    trigger="click"
                    interactive
                    placement="bottom"
                  >
                    <template v-slot:trigger>
                      <div class="alert-badge">
                        <i class="fas fa-clock"></i>
                        <span>Longo Prazo</span>
                        <span class="badge-count">{{
                          resident.pendingChecksLongTerm.length
                        }}</span>
                      </div>
                    </template>
                    <div class="tooltip-content">
                      <h6 class="tooltip-title">Medicamentos de Longo Prazo</h6>
                      <div
                        v-for="(item, key) in resident.pendingChecksLongTerm"
                        :key="key"
                        class="tooltip-item"
                      >
                        <span class="tooltip-date">{{
                          formatDate(item.date, false)
                        }}</span>
                        <button
                          @click="
                            handleToResidentByCheck(resident.id, item.date)
                          "
                          class="tooltip-action"
                        >
                          Checar
                        </button>
                      </div>
                    </div>
                  </tippy>
                </div>

                <div
                  v-if="
                    resident.advanceNotification.data &&
                    resident.advanceNotification.count_separate > 0
                  "
                  class="alert-item"
                >
                  <tippy
                    arrow
                    theme="light"
                    trigger="click"
                    interactive
                    placement="bottom"
                  >
                    <template v-slot:trigger>
                      <div class="alert-badge alert-separate-medication">
                        <i class="fas fa-pills"></i> Separar medicação
                      </div>
                    </template>
                    <div class="tooltip-content">
                      <h6 class="tooltip-title">Separar medicamentos</h6>
                      <div class="tooltip-item">
                        <span class="tooltip-date">{{
                          formatDate(resident.advanceNotification.date, false)
                        }}</span>
                        <button
                          @click="
                            handleToResidentByCheck(
                              resident.id,
                              resident.advanceNotification.date
                            )
                          "
                          class="tooltip-action"
                        >
                          Separar
                        </button>
                      </div>
                    </div>
                  </tippy>
                </div>

                <div
                  v-if="
                    resident.advanceNotification.data &&
                    resident.advanceNotification.count_check > 0
                  "
                  class="alert-item alert-primary"
                >
                  <tippy
                    arrow
                    theme="light"
                    trigger="click"
                    interactive
                    placement="bottom"
                  >
                    <template v-slot:trigger>
                      <div class="alert-badge">
                        <i class="fas fa-syringe"></i>
                        <span>Administrar medicação</span>
                      </div>
                    </template>
                    <div class="tooltip-content">
                      <div class="tooltip-item">
                        <span class="tooltip-date">{{
                          formatDate(resident.advanceNotification.date, false)
                        }}</span>
                        <button
                          @click="
                            handleToResidentByCheck(
                              resident.id,
                              resident.advanceNotification.date
                            )
                          "
                          class="tooltip-action"
                        >
                          Administrar
                        </button>
                      </div>
                    </div>
                  </tippy>
                </div>

                <div v-if="resident.schedules.length > 0" class="alert-item">
                  <tippy
                    arrow
                    theme="light"
                    trigger="click"
                    interactive
                    placement="bottom"
                  >
                    <template v-slot:trigger>
                      <div class="alert-badge alert-info">
                        <i class="fas fa-calendar"></i>
                        Agendamentos com data de hoje
                        <span class="badge-count">{{
                          resident.schedules.length
                        }}</span>
                      </div>
                    </template>
                    <div class="tooltip-content">
                      <h6 class="tooltip-title">Agendamentos</h6>
                      <div
                        v-for="(item, key) in resident.schedules"
                        :key="key"
                        class="tooltip-item"
                      >
                        <span class="tooltip-date">{{
                          item.schedule_type_name
                        }}</span>
                        <button
                          @click="
                            directToCalendar(
                              item.resident_id,
                              item.schedule_type_id
                            )
                          "
                          class="tooltip-action"
                        >
                          Verificar
                        </button>
                      </div>
                    </div>
                  </tippy>
                </div>
                <div v-if="!resident.existPrescription" class="alert-item">
                  <div class="alert-badge alert-no-prescription">
                    <i class="fas fa-info-circle"></i>
                    Não possui prescrição normal ativa
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div
            v-if="!loading && residents.length == 0 && errors.length == 0"
            class="no-results"
          >
            <i class="fas fa-search no-results-icon"></i>
            <h3 class="no-results-title">Nenhum residente encontrado</h3>
            <p class="no-results-text">
              Tente ajustar os filtros para encontrar resultados
            </p>
          </div>

          <ErrorsMessages :errors="errors" />
        </b-overlay>
      </div>

      <div
        class="pagination-section"
        v-if="!loading && residents.length > 0 && $store.state.online"
      >
        <b-pagination
          v-model="page"
          :total-rows="total"
          :per-page="itemsPerPage"
          @input="getResidents()"
          class="modern-pagination"
          align="center"
        />
      </div>

      <v-btn
        v-if="$route.query.dataOffline"
        @click="dataOffline"
        class="offline-btn"
        color="primary"
        fixed
        bottom
        right
        fab
      >
        <i class="fas fa-download"></i>
      </v-btn>
    </div>

    <Terms v-if="terms == 0" />

    <TermsGeolocation
      v-if="terms == 1 && geolocation == 1 && terms_geolocation == 0"
    />

    <ConfirmationReading
      v-if="
        terms == 1 &&
        (geolocation == 0 || (geolocation == 1 && terms_geolocation == 1))
      "
      @reload="reloadPage"
      :docsToRead="docsToRead"
      :onClose="false"
    />
  </div>
</template>

<script>
import NavBar from "../templates/NavBar";

import AuthBySessionExpired from "../templates/Components/AuthBySessionExpired";

import ErrorsMessages from "../templates/Components/ErrorsMessages";

import Duty from "../templates/Dashboard/Duty";

import Terms from "../templates/User/terms";

import TermsGeolocation from "../templates/User/TermsGeolocation";

import api from "../services/api";

import { getAge } from "../lib/getAgeByDate";

import { formatDate, formatDateToUs } from "../lib/format";

import routes from "../routes";

import permission from "../lib/permission";

import { get } from "idb-keyval";

import { getStatic, userData } from "../lib/functions";

import APICache from "../lib/api-cache";

import ConfirmationReading from "../templates/DocsFolder/ConfirmationReading";

export default {
  name: "Dashboard",

  components: {
    NavBar,
    AuthBySessionExpired,
    Duty,
    ErrorsMessages,
    Terms,
    TermsGeolocation,
    ConfirmationReading,
  },

  data() {
    return {
      docsToRead: [],

      duty: null,

      terms: 0,

      terms_geolocation: 0,

      geolocation: 0,

      rest_home_finance: 0,

      page: 1,

      total: 0,

      itemsPerPage: 25,

      name: "",

      gender: "NONE",

      filterCare: "NONE",

      degree_of_dependence_id: "NONE",

      filter: [],

      residents: [],

      user: {},

      missing_security_questions: false,

      typesFilterByCare: [
        { value: "NONE", text: "Todos os residentes" },
        { value: "USER", text: "Cuidados cadastrados por mim" },
        { value: "ALL", text: "Todos com cuidados pendentes" },
      ],

      typesFilterByGrau: [
        { value: "NONE", text: "Não filtrar" },
        { value: "GRAU1", text: "GRAU 1" },
        { value: "GRAU2", text: "GRAU 2" },
        { value: "GRAU3", text: "GRAU 3" },
      ],

      genders: [
        { value: "NONE", text: "TODOS" },
        { value: "FEMININO", text: "FEMININO" },
        { value: "MASCULINO", text: "MASCULINO" },
      ],

      loading: false,

      errors: [],
    };
  },

  created() {
    this.retrieve();

    this.checkPeriodDuty();

    this.getDocsToRead();
  },

  methods: {
    userData,

    permission,

    formatDate,

    formatDateToUs,

    getAge,

    async missingSecurityQuestions() {
      try {
        const response = await api.get("/rest-home/users/offline-access");
        const { error, users } = response.data;
        if (!error) {
          const { id } = await get("user");
          this.missing_security_questions = !users.some(
            (user) => user.id == id
          );
        }
      } catch (error) {
        console.log(error);
        this.missing_security_questions = false;
      }
    },

    handleFilterByCare() {
      let {
        filterCare,
        filter,
        user: { id },
      } = this;
      let residents = filter;
      if (filterCare == "ALL") {
        residents = filter.filter((obj) => obj.pendingCares.length > 0);
      }
      if (filterCare == "USER") {
        residents = filter.filter(
          (obj) =>
            obj.pendingCares.length > 0 &&
            obj.pendingCares.filter((p) => String(p.user_id).indexOf(id)) > -1
        );
      }
      this.residents = residents;
    },

    async retrieve() {
      let { user } = userData();
      this.user = user;
      let {
        rest_home_finance,
        terms,
        terms_geolocation,
        geolocation,
        dashboard_monitoring,
      } = user;
      this.terms = terms;
      this.terms_geolocation = terms_geolocation;
      this.geolocation = geolocation;
      if (rest_home_finance == 1) {
        routes.push({ name: "financial", query: { nav: "overview" } });
        return;
      }
      if (dashboard_monitoring == 1) {
        routes.push({ name: "dashboard_monitoring" });
        return;
      }
      if (permission("read", "only_financial")) {
        routes.push({ name: "financial", query: { nav: "overview" } });
        return;
      }
      if (this.$store.state.online) {
        if (terms == 1) {
          let sisclindashgender = localStorage.getItem("sisclindashgender");
          if (["NONE", "FEMININO", "MASCULINO"].includes(sisclindashgender)) {
            this.gender = sisclindashgender;
          }
          this.getResidents();
          this.offlineResidents();
        }
        this.missingSecurityQuestions();
      } else {
        try {
          let { residents } = await getStatic("/offline/residents", true);
          let dataResidents = [];
          for (let resident of residents) {
            resident.advanceNotification = { data: false, date: false };
            resident.date_of_birth = null;
            resident.pendingCares = [];
            resident.pendingChecks = [];
            resident.pendingChecksLongTerm = [];
            resident.pendingSemiology = [];
            if (resident.rest_home_id == user.rest_home_id) {
              dataResidents.push(resident);
            }
          }
          this.residents = dataResidents;
        } catch (errors) {
          console.log(errors);
        }
      }
    },

    async offlineResidents() {
      try {
        let residents_cached = localStorage.getItem("residents_cached");
        let { user } = this;
        if (!residents_cached || residents_cached != user.rest_home_id) {
          let response = await api.get("/offline/residents");
          const { error } = response.data;
          if (!error) {
            APICache.cache("/offline/residents", "dynamic", response.data);
            localStorage.setItem("residents_cached", user.rest_home_id);
          }
        }
      } catch (error) {
        console.log(error);
      }
    },

    async getResidents() {
      try {
        this.loading = true;
        let { page, itemsPerPage, name, degree_of_dependence_id, gender } =
          this;
        let params = {
          page,
          itemsPerPage,
          name,
          degree_of_dependence_id,
          gender,
        };
        const response = await api.get("/rest-home/resident/dashboard", {
          params,
        });
        const { residents, error, errors, total } = response.data;
        if (error) {
          this.errors = errors;
        } else {
          this.filter = residents;
          this.residents = residents;
          this.total = total;
          this.errors = [];
        }
        localStorage.setItem("sisclindashgender", gender);
        this.loading = false;
      } catch (error) {
        console.log(error);
      }
    },

    async dataOffline() {
      try {
        await api.get("/offline/residents");
        await api.get("/offline/residents/annotations");
        await api.get("/offline/residents/vital-signs");
        await api.get("/offline/residents/checks");
        await api.get("/offline/residents/prescriptions-normal");
        await api.get("/offline/residents/prescriptions-long-term");
      } catch (error) {
        console.log(error);
      }
    },

    async checkPeriodDuty() {
      try {
        const response = await api.get("/rest-home/duty-control/period");

        const { duty } = response.data;

        this.duty = duty;
      } catch (error) {
        console.log(error);
      }
    },

    async getDocsToRead() {
      try {
        const response = await api.get("/folder/user/read-doc");

        const { docsToRead, error } = response.data;

        if (!error) {
          this.docsToRead = docsToRead;

          if (docsToRead && Object.keys(docsToRead).length > 0) {
            this.$nextTick(() => {
              this.$bvModal.show(`ConfirmationReading-${this.docsToRead.id}`);
            });
          }
        }
      } catch (error) {
        console.log(error);
      }
    },

    reloadPage() {
      window.location.reload();
    },

    openModal() {
      this.$bvModal.show("confirmationsOfDutys");
    },

    handleToResident: (id) =>
      routes.push({
        name: "resident",
        params: { id },
        query: { tab: "check", nav: "check" },
      }),

    handleToResidentByCheck: (id, date) =>
      routes.push({
        name: "resident",
        params: { id },
        query: { tab: "check", nav: "check", date: formatDateToUs(date) },
      }),

    directToCalendar: (resident_id, schedule_type_id) =>
      routes.push({
        name: "schedule",
        query: {
          tab: "check",
          nav: "check",
          resident_id,
          schedule_type_id,
        },
      }),

    handleToUserCare: (id, date) =>
      routes.push({
        name: "resident",
        params: { id },
        query: { tab: "check", nav: "annotation", date: formatDateToUs(date) },
      }),

    handleToResidentBySemiology: (id, date) =>
      routes.push({
        name: "resident",
        params: { id },
        query: { tab: "semiology", date: formatDateToUs(date) },
      }),
  },
};
</script>